import { useState, useEffect } from "react";
import React from "react";

import "flowbite";
import { ToastContainer, toast } from "react-toastify";

import UserProfile from "./UserProfile";
import { useAccount } from "wagmi";

import { Toaster } from "react-hot-toast";
import axios from "axios";
import { useSigner } from "wagmi";
import { ethers } from "ethers";
import { SubscriptionAddress } from "./Contracts/Subscription";
import { SubscriptionAbi } from "./Contracts/Subscription";

import { BoxAbi } from "./Contracts/Box";

const UserDashboard = () => {
  const JWT = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI3MzVmZGI5My00NWVjLTRiOWQtODgxMi1mMDhhYWRkMjI3YWUiLCJlbWFpbCI6ImZhaGVlbWZlcm96MTExOUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJpZCI6IkZSQTEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX0seyJpZCI6Ik5ZQzEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiM2JkYzdhZjYxYTkxNDBjM2FhOTIiLCJzY29wZWRLZXlTZWNyZXQiOiI5NmU5MTM5ZTlhYTQ2ZDhmZDRjMWM4ZjdiM2EyZGEzNGQzY2EyODY0N2U3ODRkYTliY2E0MmNkOTE2NTA4MzM3IiwiaWF0IjoxNjc5OTkxNTg5fQ.iTA1cmseF9_LFXFVgVIUfV_Q7UzqVBkhQ60XpScuhyE`;
  const { BigNumber } = require("ethers");
  const [plan, setPlans] = useState([]);
  const [newAddress, setNewAddress] = useState("");
  const [boxes, setBoxes] = useState([]);

  const [dialog, setDialog] = useState(false);
  const { address } = useAccount();
  const [email, setEmail] = useState();
  const [subAddress, setSUbAddress] = useState();
  console.log("SUBADDRES", subAddress);

  console.log("new adress", newAddress);
  localStorage.setItem("newaddress", newAddress);
  const { data: signer } = useSigner();
  let contract;
  let boxcontract;
  if (signer) {
    boxcontract = new ethers.Contract(newAddress, BoxAbi, signer);
  }

  if (signer) {
    contract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      signer
    );
  }
  const planss = localStorage.getItem("plan");
  const packages = localStorage.getItem("package");
  const token = localStorage.getItem("token");
  console.log("plan", plan);
  console.log("package", packages);
  const [show, setShow] = useState(true);
  const [index, setIndex] = useState();
  console.log("index", index);

  const [storage, setStorage] = useState("");

  const getAllBoxes = async () => {
    await contract?.getUserAllBoxesInfo(address).then((info) => {
      let res = info;
      for (let i = 0; i <= info.length - 1; i++) {
        console.log(" res Info", res[i]);
        let bContract = new ethers.Contract(res[i].boxAddress, BoxAbi, signer);

        bContract.getUsedStorage().then((ress) => {
          setBoxes((oldinfo) => [
            ...oldinfo,
            {
              res: res[i],
              usedStorage: ethers.BigNumber.from(ress).toString(),
            },
          ]);
        });

        const price = BigNumber.from(res[i]?.plan?.storageAvailable);
        const prices = price.toString();
        console.log("prices", prices);
        const round = prices / 1024;
        const sizeMb = parseInt(round);
        setStorage(sizeMb);
      }
    });
  };

  useEffect(() => {
    if (signer) {
      setBoxes([]);
      getAllBoxes();
    }
  }, [signer]);

  const inviteUser = async () => {
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/invite`,
      { email: email, subAddress: subAddress, index: index },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (res.data.success) {
      console.log("Successfuly ", res.data.msg);

      // toast(res.data.msg, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "dark",
      // });

      alert(res.data.msg);
    } else {
      console.log("error ", res.data.msg);

      // toast(res.data.msg, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "dark",
      // });
      alert(res.data.msg);
    }
  };

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <div className="antialiased bg-[#212445] w-full min-h-screen text-slate-300 relative py-4">
        <div className="grid grid-cols-12 mx-auto gap-2 sm:gap-4 md:gap-6 lg:gap-10 xl:gap-14 max-w-7xl my-10 px-2">
          <UserProfile />

          <div id="content" className="bg-[#151c2c] col-span-9 rounded-lg p-6">
            <div>
              <h1 className="font-bold py-4 uppercase">Boxes</h1>
              <div
                id="stats"
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
              >
                {boxes?.map((item, index) => (
                  <div
                    className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full"
                    key={index}
                  >
                    <div
                      className="flex flex-row items-center"
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <div className="p-4">
                        <a href="#/userfiles">
                          <div
                            className="flex justify-between gap-10 hover:cursor-pointer"
                            onClick={() => {
                              setShow(false);
                              setNewAddress(item?.res?.boxAddress);
                            }}
                          >
                            <p className="text-sm font-bold">
                              {item?.res?.boxAddress.slice(0, 4) +
                                "..." +
                                item?.res?.boxAddress.slice(-4)}
                            </p>
                            <p className="text-sm font-bold my-auto ">
                              {item?.usedStorage}kb/{storage}mb
                            </p>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default UserDashboard;
